const Ucwords = (str: string) => str.toLowerCase().replace(/\b[a-z]/g, l => l.toUpperCase())

export default Ucwords
